export default __webpack_public_path__ + "static/media/tfg-title-cn.3aa78a51.webp";